import { createContext } from 'react'

interface FeatureFlagPatientContextProps {
  patientId: string | null
  setPatientId: (id: string | null) => void
}

const FeatureFlagPatientContext = createContext<FeatureFlagPatientContextProps>({
  patientId: null,
  setPatientId: () => {}
})

export default FeatureFlagPatientContext
